/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */

window.exports = {};

import '@main';
import { carouselAnimation } from '@/front/home/lottie.js?b3f6c9ded1e3b14f301e3de5';
import '@vendor/odometer/odometer.min.js?b3f6c9ded1e3b14f301e3de5';
import '@vendor/gsap/dist/gsap.min.js?b3f6c9ded1e3b14f301e3de5';
import '@vendor/gsap/dist/CSSRulePlugin.min.js?b3f6c9ded1e3b14f301e3de5';

u.importCSS('@vendor/odometer/themes/odometer-theme-default.css');

export const Home = {};

const featureCard = $('.j-card');

featureCard.on('click', (e) => {
  const $this = $(e.currentTarget);
  const num = $this.find('.odometer')[0];
  const target = $(num).data('target');

  if ($this.hasClass('active')) {
    return;
  }

  $this.parent().find('.j-card')
    .removeClass('active');

  $this.addClass('active');

  let od = new Odometer({
    el: num,
    value: target
  })

  od.update(0);

  setTimeout(() => {
    od.update(target);
  }, 500);
});

// Wait eden40 logo data loaded
carouselAnimation.addEventListener('data_ready', async () => {
  // Show logo
  $('.c-home-loading').hide();
  $('.c-eden40-logo').fadeIn();

  // Wait a while then start images carousel
  await sleepSync(1500);

  // Wait all images loaded
  waitImagesLoaded(async () => {
    // Start carousel animation
    const container = $('.c-carousel-container');
    container.show();

    initCarousel();

    await sleepSync(1000);

    // Fade in carousel
    container.animate({ opacity: 1 }, 2000);

    await sleepSync(2000);

    // Gray to color
    $('.c-carousel-container').removeClass('c-gray-default').addClass('c-gray-in');
  });
});

let w, section, container, carousel, item, radius, itemLength, rY, ticker;
let mouseX = 0;
let mouseY = 0;
let mouseZ = 0;
let defaultX = 0.1;
let addx = 0;
let addY = 0;
let scale = 3;
const items = $('.j-carousel-item');

function setRadius(r) {
  radius = r;
}

window.setRadius = setRadius;

function initCarousel() {
  w = $(window);
  section = $('.c-carousel');
  container = $('.j-carousel-container');
  carousel = $('.j-carousel-wrapper');
  items.fadeIn();
  itemLength = items.length;
  rY = 360 / itemLength;
  let width = w.width();

  radius = Math.round((340) / Math.tan(Math.PI / itemLength));
  addY = -50;

  gsap.set(
    container,
    { perspective: 600, rotateX: -40 }
  );

  if (width < 576) {
    radius = Math.round((280) / Math.tan(Math.PI / itemLength));
    // addY = -50;
  }

  gsap.set(
    carousel,
    { z: -600 }
  );

  // Keep mobile same as Desktop
  // if (width < 992) {
  //   let totalWidth = container.width() * itemLength;
  //   addY = 0;
  //
  //   gsap.set(
  //     container,
  //     { perspective: 'inherit', rotateX: 0 }
  //   );
  //
  //   gsap.set(
  //     carousel,
  //     { z: 0 }
  //   );
  //
  //   radius = Math.round(
  //     ((totalWidth / 2) * (1 / Math.tan(Math.PI / itemLength))) / itemLength
  //   );
  // }

  for (let i = 0; i < itemLength; i++) {
    const $item = items.eq(i);

    gsap.set(
      $item,
      {
        rotationY: rY * i,
        z: radius,
        y: addY,
        transformOrigin: '50% 50% ' + -radius + 'px',
      }
    );
  }

  section.on('mouseover', (e) => {
    const $this = $(e.currentTarget);

    $this.addClass('active');
  });

  section.on('mouseleave', (e) => {
    const $this = $(e.currentTarget);

    $this.removeClass('active');
  });

  section.on(('mousemove'), (e) => {
    const $this = $(e.currentTarget);

    mouseX = -(-($this.innerWidth() * .5) + e.pageX) * .001;
    mouseY = -(-($this.innerHeight() * .5) + event.pageY) * .005;
  });

  looper();

  let startTime = Date.now();
  let scalingId;

  function scaling() {
    const elapsed = Date.now() - startTime;
    scale = easeOutCubic(elapsed, 5, -4, 5000);

    if (scale <= 1) {
      scale = 1;
    } else {
      scalingId = requestAnimationFrame(scaling);
    }
  }

  scaling();
}

function looper() {
  if (section.hasClass('active')) {
    if (mouseX >= 0.4) {
      addx += 0.4;
    }

    if (mouseX <= -0.4) {
      addx += -0.4;
    }

    if (mouseX >= -0.4 && mouseX <= 0.4) {
      addx += mouseX;
    }

    animation(addx, mouseY, mouseZ);
  }

  if (!section.hasClass('active')) {
    if (mouseX >= 0) {
      addx += 0.1;
    }

    if (mouseX < 0) {
      addx -= 0.1;
    }

    animation(addx, 0, 0);
  }

  requestAnimationFrame(looper);
}

const enableBlur = true;

function animation(x, y, z) {
  if (enableBlur) {
    itemsBlur(x);
  }

  gsap.to(
    carousel,
    1,
    {
      rotationY: x,
      rotationX: y,
      scaleX: scale,
      scaleY: scale,
      ease: Quint.easeOut,
    }
  );
}

const segment = 365 / items.length;

function itemsBlur(x) {
  let deg;

  if (x >= 0) {
    deg = 360 - (x % 360);
  } else {
    deg = Math.abs(x) % 360;
  }

  items.each((i, item) => {
    // Calc every item positions in circle.
    const itemPos = i * segment;

    // Calc item rotate from circle rotate deg.
    const rotate = Math.abs((itemPos - deg) % 360);

    // Calc item distance (0-180) with screen (position 0).
    const itemDistance = 180 - Math.abs(180 - rotate);

    // Convert distance to 10 base.
    const tenDistance = Math.min(100, Math.abs(itemDistance / 180 * 100));

    // Debug info.
    // item.dataset.key = i;
    // item.dataset.deg = deg;
    // item.dataset.pos = itemPos;
    // // item.dataset.dis = itemDistance;
    // item.dataset.itemDistance = itemDistance;
    // item.dataset.tenDistance = tenDistance;
    // item.dataset.blur = (tenDistance / 5) - 4;
    // item.dataset.op = 1 - (tenDistance / 100) + 0.2;

    const blur = Math.max((tenDistance / 5) - 4, 0);

    gsap.to(
      item,
      1,
      {
        filter: enableBlur ? `blur(${blur}px)` : null,
        opacity: Math.min(1 - (tenDistance / 100) + 0.4, 1)
      }
    );
  });
}

function waitImagesLoaded(callback) {
  const images = $('.j-carousel-item');
  let loadedImages = 0;

  images.each((i, image) => {
    if (image.complete) {
      checkedAllLoaded();
    } else {
      $(image).on('load', () => {
        checkedAllLoaded();
      });
    }
  });

  function checkedAllLoaded() {
    loadedImages++;

    if (loadedImages === images.length) {
      callback();
    }
  }
}

// Numbers
$(() => {
  const jCard = $('.j-card');
  const numOne = jCard.find('.odometer')[0];
  const numSix = jCard.find('.odometer')[5];
  const targetOne = $(numOne).data('target');
  const targetSix = $(numSix).data('target');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          let firstOd = new Odometer({
            el: numOne,
            value: targetOne,
          })

          firstOd.update(0);

          setTimeout(() => {
            firstOd.update(targetOne);
          }, 500);

          let SixthOd = new Odometer({
            el: numSix,
            value: targetSix,
          })

          SixthOd.update(0);

          setTimeout(() => {
            SixthOd.update(targetSix);
          }, 500);
        }, 3000);
      }
    });
  });

  observer.observe(document.querySelector('.c-feature'));

  // thoseday bg rotate
  const observer2 = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          $('.c-thoseday.c-about').find('.c-item__bg').addClass('rotate');
        }, 500);
      } else {
        $('.c-thoseday.c-about').find('.c-item__bg').removeClass('rotate');
      }
    });
  });

  observer2.observe(document.querySelector('.c-thoseday.c-about'));

  $(window).on('resize', () => {
    // initCarousel();
  });

  $(window).on('scroll', (e) => {
    if (e.currentTarget.scrollY > 200) {
      $('.c-down').removeClass('show');
    } else {
      $('.c-down').addClass('show');
    }
  });
});

// @see https://github.com/bameyrick/js-easing-functions/blob/master/src/index.ts#L20
function easeOutCubic(elapsed, initialValue, amountOfChange, duration) {
  return amountOfChange * ((elapsed = elapsed / duration - 1) * elapsed * elapsed + 1) + initialValue;
}

function sleepSync(duration) {
  return new Promise((resolve) => {
    setTimeout(resolve, duration);
  });
}
